import angular from 'angular';

import auth from '../auth';

import rememberPasswordLegacyContainer from './containers/rememberPasswordLegacy.container';
import Legacy from './services/legacy';
import routeProviderConfig from './config/routeProvider.config';

const legacyModule = angular.module('legacy', [auth])
.config(routeProviderConfig)
.component('rememberPasswordLegacyContainer', rememberPasswordLegacyContainer)
.service('legacy', Legacy);

export default legacyModule.name;
